import { dockEntries } from "@/mocks/blackmole";
import { dotTone, solidTone, textTone } from "./tone";

export default function DockEntries() {
  return (
    <section id="dock" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6 md:py-16">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              <span className="mr-1 inline-block h-2 w-2 rounded-sm bg-primary-500"></span>
              追踪入口台
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              六个分区入口，按线把突发爆料与最新猛料收进同一张台面，点哪个进哪条线。
            </p>
          </div>
          <a
            href="#feed"
            className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-600 sm:inline-flex"
          >
            全部快讯
            <i className="ri-arrow-right-up-line text-sm"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {dockEntries.map((d) => (
            <a
              key={d.key}
              href="#feed"
              className="group relative flex cursor-pointer items-start gap-4 overflow-hidden rounded-xl border border-background-200 bg-background-100/70 p-5 transition-colors hover:border-primary-200 hover:bg-background-50"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-lg ${solidTone[d.tone]}`}
              >
                <i className={d.icon}></i>
              </span>
              <span className="flex flex-1 flex-col">
                <span className="flex items-center gap-2">
                  <span className="text-base font-semibold text-foreground-950">{d.name}</span>
                  <span className="rounded-md bg-background-200/70 px-1.5 py-0.5 text-xs font-bold text-foreground-800">
                    {d.today}
                  </span>
                </span>
                <span className="mt-1 text-xs text-foreground-500">{d.alias}</span>
                <span className={`mt-3 flex items-center gap-1.5 text-xs font-medium ${textTone[d.tone]}`}>
                  <span className={`h-1.5 w-1.5 rounded-full ${dotTone[d.tone]}`}></span>
                  {d.state}
                  <i className="ri-arrow-right-line ml-auto transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}